import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M12.909 5.625v8.75m-5.417-8.75v8.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);